import http from '../api/http';

export default {
    /*upload({params, callback}){ // 上传文件
        http.post(`/v1/venue/home/cvsUpload`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },*/
    upload({params, type, callback}){ // 上传文件
        http.post(`/v1/venue/cvsUpload?uploadType=${type}`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    average({params, callback}){ // 平均
        http.get(`/v1/venue/revenueHistory/weekEnding`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    history({params, callback}){ // 历史
        http.get(`/v1/venue/revenueHistory/weekEndingHistory`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    update({params, callback}){ // 更新收入历史数据中的某一条数据
        http.put(`/v1/venue/updateRevenueHistory`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    over({params, callback}){ // 有需要覆盖的数据时重新上传
        http.post(`/v1/venue/overwriteCvs`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    progress({callback}){ // 步骤状态
        http.get(`/v1/home/stepStatus`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },

    saveTargetRevenueForecast ({payload, callback}) {
        http.post(`/v1/venue/saveTargetRevenueForecast`, payload).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },

    getTargetRevenueForecastYear ({payload, callback}) {
        http.get(`/v1/venue/getTargetRevenueForecastYear?year=${payload}`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },

    async getTargetRevenueForecastWeek (payload) {
        let url = `/v1/venue/getTargetRevenueForecastWeek?weekEndingDate=${payload}`

        return http.get(url)
    },

}


// WEBPACK FOOTER //
// ./src/api/revenue.js